import { PropsWithChildren } from 'react';

import { cn, NoddiIcon, NoddiIconName, type VariantProps } from 'noddi-ui-common';
import { NoddiSpinner } from '../Feedback/NoddiSpinner';
import { noddiButtonVariants } from '../Inputs/NoddiButton';

type NoddiDummyButtonProps = VariantProps<typeof noddiButtonVariants> & {
  loading?: boolean;
  className?: string;
} & ({ startIcon?: NoddiIconName; endIcon?: never } | { endIcon?: NoddiIconName; startIcon?: never });

export const NoddiDummyButton = ({
  className,
  variant,
  size,
  endIcon,
  startIcon,
  loading,
  children
}: PropsWithChildren<NoddiDummyButtonProps>) => {
  const buttonClassName = cn(noddiButtonVariants({ variant, size }), className);

  return (
    <div className={buttonClassName}>
      {startIcon && !loading && <NoddiIcon name={startIcon} />}
      {loading && !endIcon && <NoddiSpinner className='text-current' size='small' />}

      <span className='text-left'>{children}</span>

      {loading && endIcon && <NoddiSpinner className='text-current' size='small' />}
      {endIcon && !loading && <NoddiIcon name={endIcon} />}
    </div>
  );
};
